// src/App.js
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';

function App() {
  return (
      <Routes>
        {/* Admin Giriş Sayfası */}
        <Route path='/' element={<Login />} />
        <Route path='/login' element={<Login />} />

        {/* Yönetim Paneli (Dashboard) Rotası */}
        <Route path='/admin/dashboard' element={<Dashboard />} />
      </Routes>
  );
}

export default App;